import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type AgentOnboardingAudience } from './agentOnboardingAnalytics';
import META from './useTrackAgentOnboardingStarted.meta';
import { withWorkspaceAgentCategory } from './workspaceAgentAnalytics';

export type { AgentOnboardingAudience } from './agentOnboardingAnalytics';

export type UseTrackAgentOnboardingStartedParams = {
  audience: AgentOnboardingAudience;
};

export const useTrackAgentOnboardingStarted = () => {
  const { track } = useAnalyticsUtilities();

  const trackAgentOnboardingStarted = useCallback(
    (params: UseTrackAgentOnboardingStartedParams) => {
      track(META.name, withWorkspaceAgentCategory(params));
    },
    [track],
  );

  return { trackAgentOnboardingStarted };
};
